module.exports = "import React from 'react';\nimport AppBar from 'material-ui/AppBar';\n\n/**\n * A simple example of `AppBar` with an icon on the right.\n * By default, the left icon is a navigation-menu.\n */\nconst AppBarExampleIcon = () => (\n  <AppBar\n    title=\"Title\"\n    iconClassNameRight=\"muidocs-icon-navigation-expand-more\"\n  />\n);\n\nexport default AppBarExampleIcon;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/AppBar/ExampleIcon.js
 ** module id = 930
 ** module chunks = 0
 **/